export default {
  v3OfficialTopUpCenterTitle: 'ศูนย์เติมเงินเว็บทางการ',
  v3OfficialTopUpCenterKeyword: 'ศูนย์เติมเงินเว็บทางการ',
  v3OfficialTopUpCenterDescription: 'ศูนย์เติมเงินเว็บทางการ',
  v3SafeAndFast: 'ปลอดภัยไร้ความเสี่ยง รวดเร็วทันใจ',
  v3Shop: 'มอลล์',
  v3ShoppingCart: 'รถเข็น',
  v3MembershipCenter: 'ศูนย์สิทธิประโยชน์(ศูนย์สมาชิก)',
  v3Login: 'ล็อกอิน',
  v3Account: 'บัญชี',
  v3EnterAccountName: 'กรุณาใส่ชื่อบัญชี',
  v3Password: 'รหัสผ่าน',
  v3EnterPassword: 'กรุณาใส่รหัสผ่าน',
  v3ForgotPassword: 'ลืมรหัสผ่าน',
  v3EnterUID: 'กรุณาใส่ UID',
  v3OTP: 'OTP',
  v3EnterOTP: 'กรุณาใส่ OTP',
  v3SelectTopUpCharacter: 'เลือกตัวละครที่ต้องการเติมเงิน',
  v3SelectServer: 'กรุณาเลือกเซิร์ฟเวอร์',
  v3Confirm: 'ยืนยัน',
  v3CharacterNotFound:
    'หากไม่พบตัวละคร กรุณาลองล็อกอินตัวละครภายในเกมก่อนแล้วค่อยล็อกอินหน้าเติมเงินหรือติดต่อฝ่ายบริการลูกค้า',
  v3Logout: 'ล็อกเอาท์',
  v3SwitchAccount: 'สลับบัญชี',
  v3MyCoupons: 'คูปองของฉัน',
  v3BenefitsCenter: 'ศูนย์สิทธิประโยชน์',
  v3TopUpBenefits: 'โบนัสเติมเงิน',
  v3MoreSettings: 'ตั้งค่าเพิ่มเติม',
  v3RememberLoginStatus: 'จดจำสถานะล็อกอินของฉัน',
  v3OrderQuery: 'ตรวจสอบการสั่งซื้อ',
  v3ContactCustomerService: 'ติดต่อฝ่ายบริการลูกค้า',
  v3LoginWithApp: 'ล็อกอินด้วยแอป',
  v3ChooseOtherLoginMethod: 'เลือกวิธีล็อกอินอื่น',
  v3ConnectingToGameApp: 'กำลังเชื่อมต่อแอปเกม',
  v3EnsureGameInstalled:
    'กรุณาตรวจสอบว่าอุปกรณ์นี้ติดตั้งเกมแล้ว หากเกมไม่ตอบสนองหรือล็อกอินล้มเหลว โปรดอัพเดทเกมสู่เวอร์ชั่นล่าสุดจากแอปสโตร์หรือเปลี่ยนเบราว์เซอร์อื่น',
  v3OpenGame: 'เปิดเกม',
  v3DownloadGame: 'ดาวน์โหลดเกม',
  v3UpdateGameIfOpenFails:
    'หากเปิดเกมล้มเหลว โปรดอัพเดทเกมสู่เวอร์ชั่นล่าสุดจากแอปสโตร์',
  v3ClickToDownloadLatestVersion:
    'หรือแตะปุ่มดาวน์โหลดเกมเพื่อดาวน์โหลดเวอร์ชั่นล่าสุด',
  v3LoggingIntoOfficialTopUpCenter: 'คุณกำลังล็อกอิน[ศูนย์เติมเงินเว็บทางการ]',
  v3CurrentAccount: 'บัญชีปัจจุบัน : xxxxxxxxxx',
  v3WelcomeToOfficialTopUpCenter: 'ยินดีต้อนรับสู่ศูนย์เติมเงินเว็บทางการ',
  v3OfficialAuthorizedLogin: 'ล็อกอินเกมทางการ ปลอดภัยไร้ความเสี่ยง',
  v3TermsOfService: 'ข้อกำหนดบริการ',
  v3PrivacyPolicy: 'นโยบายความเป็นส่วนตัว',
  v3ThirdPartySocialAccountDescription: 'คำอธิบายบัญชีโซเชียลบุคคลที่สาม',
  v3BindSocialAccountInGameFirst:
    'กรุณาผูกบัญชีโซเชียลที่ศูนย์ผู้ใช้งานภายในเกมก่อน ค่อยใช้บัญชีโซเชียลที่ผูกเพื่อล็อกอิน',
  v3FirstTopUp15PercentOff: 'เติมเงินครั้งแรกรับส่วนลดสูงสุด 15%',
  v3MoreTopUpRebates: 'แจกคืนกำไรเติมเงินไม่อั้น',
  v3LoginToViewOffers: 'ล็อกอินดูโปรฯ',
  v3TopUpEnvironmentChecking: 'กำลังตรวจสอบสถานะเติมเงิน……',
  v3SafeToUse: 'ปลอดภัย โปรดใช้อย่างวางใจ',
  v3LimitedTimeBenefits: 'โบนัสจำกัดเวลา',
  v3EventRules: 'กติกากิจกรรม',
  v3MoreEvents: 'กิจกรรมเพิ่มเติม',
  v3Claim: 'รับ',
  v3Completed: 'สำเร็จแล้ว',
  v3GoTo: 'ไป',
  v3ViewDetails: 'ดูรายละเอียด',
  v3RecommendedProducts: 'สินค้าแนะนำ',
  v3SearchProductName: 'ค้นหาชื่อสินค้า',
  v3AllCategories: 'ประเภททั้งหมด',
  v3PopularSort: 'ลำดับยอดฮิต',
  v3PriceAscending: 'ราคาต่ำสู่สูง',
  v3PriceDescending: 'ราคาสูงสู่ต่ำ',
  v3DiamondBonus10Percent: 'โบนัสเพชร 10%',
  v3YuanbaoBonus10Percent: 'โบนัสตำลึง 10%',
  v3ExtraBonus10Percent: 'แจกเพิ่ม 10%',
  v3FirstTopUpDouble: 'เติมครั้งแรกสองเท่า',
  v3FirstExtraBonus: 'แจกเพิ่มครั้งแรก',
  v3ProductDetails: 'รายละเอียดสินค้า',
  v3AddToCart: 'เพิ่มเข้ารถเข็น',
  v3AddedToCart: 'เพิ่มเข้ารถเข็นแล้ว',
  v3BuyNow: 'ซื้อทันที',
  v3NoItemsInCart: 'คุณยังไม่เลือกสินค้าเข้ารถเข็น',
  v3SelectedItemsN: 'เลือกสินค้าแล้ว(${n})',
  v3RemoveFromCart: 'ยืนยันที่จะนำออกจากรถเข็นไหม',
  v3Yes: 'ยืนยัน',
  v3No: 'ยกเลิก',
  v3LimitOnePerPurchase: 'สินค้านี้จำกัดซื้อครั้งละ 1 ชิ้น',
  v3ItemPrice: 'ราคาสินค้า',
  v3Tax: 'ภาษี',
  v3ExtraGift: 'แจกเพิ่ม',
  v3Total: 'รวม',
  v3ProceedToPayment: 'ไปชำระเงิน',
  v3SelectCoupon: 'เลือกคูปอง',
  v3UnavailableCoupons: 'คูปองที่ใช้ไม่ได้',
  v3OneCouponPerOrder: 'จำกัดใช้ 1 ใบต่อออเดอร์',
  v3DiscountCoupon: 'คูปองส่วนลด',
  v3ThresholdCoupon: 'คูปองส่วนลดเมื่อครบยอด',
  v3MinSpendCoupon: 'ครบยอด xx USD จะสามารถใช้',
  v3MaxDiscountCoupon: 'ลดสูงสุด xxxx USD',
  v3LimitedChannel: 'ช่องทางลิมิเต็ดสามารถใช้ได้',
  v3AllChannels: 'ช่องทางทั้งหมดสามารถใช้ได้',
  v3SpecificProducts: 'สินค้าที่กำหนดสามารถใช้ได้',
  v3AllProducts: 'สินค้าทั้งหมดสามารถใช้ได้',
  v3NotYetTimeToUse: 'ยังไม่ถึงเวลาใช้งาน',
  v3Expired: 'หมดอายุแล้ว',
  v3Used: 'ใช้แล้ว',
  v3ValidityPeriod: 'มีอายุ:',
  v3ConfirmUse: 'ยืนยันใช้',
  v3ChangeProduct: 'เปลี่ยนสินค้า',
  v3ConfirmPaymentOrder: 'ยืนยันชำระเงินออเดอร์',
  v3StoredValueRole: 'ตัวละครเติมเงิน',
  v3TotalNProducts: 'รวมสินค้า ${n} ชิ้น',
  v3SelectPaymentMethod: 'เลือกช่องทางชำระเงิน',
  v3PayNow: 'ชำระเงินทันที',
  v3MorePaymentMethods: 'ช่องทางชำระเงินเพิ่มเติม',
  v3NoAvailablePaymentMethodContactSupport:
    'ไม่พบช่องทางชำระเงินที่ใช้ได้? ติดต่อฝ่ายบริการลูกค้า',
  v3AvailableCoupons: 'คูปองที่ใช้ได้',
  v3Extra10Percent: 'โบนัส 10%',
  v3LastSelection: 'เลือกครั้งก่อน',
  v3RecommendedUsage: 'แนะนำใช้',
  v3PopularChoice: 'ตัวเลือกยอดฮิต',
  v3PaymentSuccess: 'ชำระเงินสำเร็จ',
  v3PaymentFailure: 'ชำระเงินล้มเหลว',
  v3TopUpFailureMessage:
    'ขอโทษด้วย เติมเงินล้มเหลว โปรดลองส่งออเดอร์ใหม่หรือติดต่อเราผ่านปุ่มฝ่ายบริการลูกค้าข้างใต้',
  v3Game: 'เกม',
  v3UID: 'UID',
  v3OrderNumber: 'รหัสออเดอร์',
  v3ProductContent: 'เนื้อหาสินค้า',
  v3ViewProductDetails: 'ดูรายละเอียดสินค้า',
  v3PaymentMethod: 'ช่องทางชำระเงิน',
  v3Complete: 'สำเร็จ',
  v3TopUpAgain: 'เติมอีก 1 รายการ',
  v3FriendlyReminderSaveOrderInfo:
    'หมายเหตุ : แคปภาพบันทึกข้อมูลออเดอร์ เพื่อสะดวกต่อการดำเนินออเดอร์ของคุณ',
  v3RechargeAgain: 'เติมเงินใหม่',
  v3TransactionInProgress: 'กำลังดำเนินซื้อขาย',
  v3CompletePaymentInChannel: 'โปรดไปช่องทางชำระเงินเพื่อชำระเงินออเดอร์',
  v3RestAssuredFastDeliveryAfterPayment:
    'โปรดวางใจ หลังเราได้รับผลชำระเงินออเดอร์ จะส่งไอเทมสินค้าให้คุณโดยเร็วที่สุด',
  v3SaveOrderInfoForProgress:
    'คุณสามารถแคปภาพบันทึกข้อมูลออเดอร์เพื่อสะดวกต่อการตรวจสอบความคืบหน้าการซื้อขาย',
  v3PaymentCompleted: 'ฉันชำระเงินสำเร็จแล้ว',
  v3AddToHomeScreen: 'เพิ่มสู่จอหลัก',
  v3AddShortcutForBonus: 'เพิ่มช่องทางลัดเดสก์ท็อป รับรางวัลเพิ่ม',
  v3ShareSuccess: 'แชร์สำเร็จ',
  v3ShareFailure: 'แชร์ล้มเหลว',
  v3RewardClaimed: 'รับรางวัลสำเร็จ',
  v3RewardClaimFailed: 'รับรางวัลล้มเหลว',
  v3EventNotStarted: 'ยังไม่เริ่มกิจกรรม',
  v3EventEnded: 'กิจกรรมสิ้นสุดแล้ว',
  v3ClickSelectCoupon: 'คลิกเพื่อเลือกคูปอง',
  v3CouponsRecommendedUsed: 'ใช้คูปองที่แนะนำแล้ว',
  v3CouponsSelected: 'เลือกคูปองแล้ว',
  v3NoCouponsAvaliable: 'ไม่มีคูปองที่ใช้ได้',
  v3SupplementStatus: 'สถานะ',
  v3SupplementNormal: 'ปกติ',
  v3SupplementBanned: 'ถูกแบน',
  v3SupplementPendingPayment: 'รอการชำระเงิน',
  v3SupplementSwitchCharacter: 'เปลี่ยนตัวละคร',
  v3SupplementAccountInfoInvalid: 'ข้อมูลบัญชีไม่ถูกต้อง',
  v3SupplementContactGSForTopUpLink: 'กรุณาติดต่อ GS เพื่อรับลิงก์เติมเงิน',
  v3SupplementTopUpCompleted: 'เติมเงินเสร็จสิ้น:',
  v3SupplementTotalRefundOrders: 'คำสั่งคืนเงินทั้งหมด {} รายการ',
  v3SupplementPendingSupplementAmount: 'จำนวนเงินที่รอการชำระ:',
  v3SupplementAccountCharacterNormalNoPaymentNeeded:
    'บัญชี/ตัวละครปกติ ไม่ต้องชำระเงิน',
  v3SupplementEnjoyYourGame: 'ขอให้สนุกกับเกมของคุณ!!',
  v3SupplementOrderInformation: 'ข้อมูลการสั่งซื้อ',
  v3SupplementPendingPaymentAmount: 'จำนวนเงินที่ต้องชำระ:',
  v3LookUpCouponRule: 'เช็คดูกติกาการแจกคูปอง',
  v3SwitchOldVersion: 'เปลี่ยนไปยังแพลตฟอร์ม การชำระเงินเวอร์ชันเก่า',
  v3FirstTopUpGiveaway: 'เติมครั้งแรกแจก',
  v3SecureConnection: 'กำลังเชื่อมต่อแบบปลอดภัย',
  v3RequestTimeOut: 'โหลดข้อมูลล้มเหลว โปรดลองใหม่อีกครั้ง',
  v3ConfirmLeave: 'ออกหรือไม่?',
  v3NoSubmitOrder:
    'ในรถเข็นของท่านมีสินค้าที่ยังไม่ได้ชำระเงิน การออกไปตอนนี้อาจทำให้พลาดของที่ถูกใจได้!',
  v3ContinueSubmit: 'ซื้อต่อ',
  v3LeaveSubmit: 'ออก',
  v3RecentBug: 'ซื้อล่าสุด',
  v3PwaTapShareOrMenuIcon: 'คลิกไอคอน แชร์ หรือ เมนู บนแถบเครื่องมือเบราว์เซอร์',
  v3PwaFindAndTapAddToHomeScreen: 'ค้นหาและคลิก "เพิ่มลงในหน้าจอหลัก" ในตัวเลือก',
  v3LaunchFromDesktopAndRewardToMailbox: 'กรุณาเปิดจากเดสก์ท็อป\nเลือกตัวละครแล้วรางวัลจะถูกส่งไปยังกล่องจดหมาย',
  v3ClaimSuccessCheckMailbox: 'รับรางวัลสำเร็จ\nกรุณาตรวจสอบจดหมายในเกม'
};
